/**
 * useFileUrl — resolves a Vault document id into a fresh 1-hour signed
 * download URL. Returns the URL string (or null while loading / on
 * error). Backwards-compatible name preserved for arche consumers that
 * pre-date the user_files → Vault Documents rename.
 */

import { useEffect, useState } from 'react';
import { api } from '@/lib/api';

export function useFileUrl(documentId: string | null | undefined): string | null {
  const [url, setUrl] = useState<string | null>(null);

  useEffect(() => {
    if (!documentId) {
      setUrl(null);
      return;
    }
    let cancelled = false;
    api
      .getVaultDocumentDownloadUrl(documentId)
      .then((r) => {
        if (!cancelled) setUrl(r.url);
      })
      .catch(() => {
        if (!cancelled) setUrl(null);
      });
    return () => {
      cancelled = true;
    };
  }, [documentId]);

  return url;
}
